import MarketCard from 'Components/Cards/MarketCard'
import MarketHeader from 'Components/MarketHeader'
import { useSelector } from 'react-redux'
import { headings } from './MarketData'

const Fonts = () => {
  const { items: fonts, category_name: categoryName } = useSelector(
    (state) => state.market.catalog.font
  )

  return (
    <div className='w-full'>
      <MarketHeader {...headings.font} />
      <div className='grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6'>
        {Object.keys(fonts)?.map((item) => {
          const {
            item_id: id,
            item_name: name,
            item_photo_url: photoURL,
            item_description: itemDescription,
            item_price: price,
            category_id: categoryId,
            isPurchased
          } = fonts[item]
          return (
            <div key={id}>
              <MarketCard
                title={name}
                imgURL={photoURL}
                price={price}
                itemDescription={itemDescription}
                categoryId={categoryId}
                itemId={id}
                isPurchased={isPurchased}
                categoryName={categoryName}
                limit={2}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Fonts
